<nz-input-group [nzPrefix]="suffixIconSearch">
  <input type="text" nz-input placeholder="Search by all fields" [(ngModel)]="table.searchValue" />
</nz-input-group>
<ng-template #suffixIconSearch>
  <i nz-icon nzType="search" class="icon_custom-search"></i>
</ng-template>
